import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Serve the pdf.js worker locally (version-matched) instead of ng2-pdf-viewer's
// default CDN. Avoids blank PDFs when the CDN worker is blocked by CSP/network
// or drifts from the bundled pdfjs-dist version.
(window as any).pdfWorkerSrc = '/assets/pdf.worker.min.js';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
